import logo from "../images/splash-logo.png";

const Privacy = () => {
  return (
    <div dir="ltr">
      <div className=" bg-slate-200 py-4">
        <div className="container mx-auto px-10">
          <img src={logo} alt="specter logo" />
        </div>
      </div>
      <div className="container mx-auto px-10">
        <h1 className="text-3xl font-bold underline text-center py-8 mb-6">
          Terms & Conditions and Privacy Policy
        </h1>

        <h2 className="text-xl font-bold pb-2">AGREEMENT TO OUR LEGAL TERMS</h2>

        <ol className="list-decimal list-inside space-y-6">
          <div>
            <li className="text-xl font-bold pb-2">OUR SERVICES</li>
            <p className="font-medium">
              The information provided when using the Services is not intended
              for distribution to or use by any person or entity in any
              jurisdiction or country where such distribution or use would be
              contrary to law or regulation or which would subject us to any
              registration requirement within such jurisdiction or country.
              Accordingly, those persons who choose to access the Services from
              other locations do so on their own initiative and are solely
              responsible for compliance with local laws, if and to the extent
              local laws are applicable.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">
              INTELLECTUAL PROPERTY RIGHTS
            </li>
            <p className="font-medium">
              We reserve the right to refuse any order placed through the
              Services. We may, in our sole discretion, limit or cancel
              quantities purchased per person, per household, or per order.
              These restrictions may include orders placed by or under the same
              customer account, the same payment method, and/or orders that use
              the same billing or shipping address. We reserve the right to
              limit or prohibit orders that, in our sole judgement, appear to be
              placed by dealers, resellers, or distributors.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">RETURN/REFUNDS POLICY</li>
            <p className="font-medium">
              All sales are final and no refund will be issued.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">SOFTWARE</li>
            <p className="font-medium">
              We may include software for use in connection with our Services.
              If such software is accompanied by an end user licence agreement
              ('EULA'), the terms of the EULA will govern your use of the
              software. If such software is not accompanied by a EULA, then we
              grant to you a non-exclusive, revocable, personal, and
              non-transferable licence to use such software solely in connection
              with our services and in accordance with these Legal Terms. Any
              software and any related documentation is provided 'AS IS' without
              warranty of any kind, either express or implied, including,
              without limitation, the implied warranties of merchantability,
              fitness for a particular purpose, or non-infringement. You accept
              any and all risk arising out of use or performance of any
              software. You may not reproduce or redistribute any software
              except in accordance with the EULA or these Legal Terms.
            </p>
            <p className="font-medium pt-6">
              You may not access or use the Services for any purpose other than
              that for which we make the Services available. The Services may
              not be used in connection with any commercial endeavours except
              those that are specifically endorsed or approved by us.
            </p>
          </div>

          <div>
            <p className="text-xl font-semibold pb-3">
              As a user of the Services, you agree not to
            </p>
            <ul className="text-sm list-disc list-outside space-y-2 px-8">
              <li>
                Systematically retrieve data or other content from the Services
                to create or compile, directly or indirectly, a collection,
                compilation, database, or directory without written permission
                from us.
              </li>
              <li>
                Trick, defraud, or mislead us and other users, especially in any
                attempt to learn sensitive account information such as user
                passwords.
              </li>
              <li>
                Circumvent, disable, or otherwise interfere with
                security-related features of the Services, including features
                that prevent or restrict the use or copying of any Content or
                enforce limitations on the use of the Services and/or the
                Content contained therein.
              </li>
              <li>
                Disparage, tarnish, or otherwise harm, in our opinion, us and/or
                the Services.
              </li>
              <li>
                Use any information obtained from the Services in order to
                harass, abuse, or harm another person.
              </li>
              <li>
                Make improper use of our support services or submit false
                reports of abuse or misconduct.
              </li>
              <li>
                Use the Services in a manner inconsistent with any applicable
                laws or regulations.
              </li>
              <li>
                Engage in unauthorised framing of or linking to the Services.
              </li>
              <li>
                Upload or transmit (or attempt to upload or to transmit)
                viruses, Trojan horses, or other material, including excessive
                use of capital letters and spamming (continuous posting of
                repetitive text), that interferes with any party’s uninterrupted
                use and enjoyment of the Services or modifies, impairs,
                disrupts, alters, or interferes with the use, features,
                functions, operation, or maintenance of the Services.
              </li>
              <li>
                Engage in any automated use of the system, such as using scripts
                to send comments or messages, or using any data mining, robots,
                or similar data gathering and extraction tools.
              </li>
              <li>
                Delete the copyright or other proprietary rights notice from any
                Content.
              </li>
              <li>
                Attempt to impersonate another user or person or use the
                username of another user.
              </li>
              <li>
                Upload or transmit (or attempt to upload or to transmit) any
                material that acts as a passive or active information collection
                or transmission mechanism, including without limitation, clear
                graphics interchange formats ('gifs'), 1×1 pixels, web bugs,
                cookies, or other similar devices (sometimes referred to as
                'spyware' or 'passive collection mechanisms' or 'pcms').
              </li>
              <li>
                Interfere with, disrupt, or create an undue burden on the
                Services or the networks or services connected to the Services.
              </li>
              <li>
                Harass, annoy, intimidate, or threaten any of our employees or
                agents engaged in providing any portion of the Services to you.
              </li>
              <li>
                Attempt to bypass any measures of the Services designed to
                prevent or restrict access to the Services, or any portion of
                the Services.
              </li>
              <li>
                Copy or adapt the Services' software, including but not limited
                to Flash, PHP, HTML, JavaScript, or other code
              </li>
              <li>
                Except as permitted by applicable law, decipher, decompile,
                disassemble, or reverse engineer any of the software comprising
                or in any way making up a part of the Services.
              </li>
              <li>
                Except as may be the result of standard search engine or
                Internet browser usage, use, launch, develop, or distribute any
                automated system, including without limitation, any spider,
                robot, cheat utility, scraper, or offline reader that accesses
                the Services, or use or launch any unauthorised script or other
                software.
              </li>
              <li>
                Use a buying agent or purchasing agent to make purchases on the
                Services.
              </li>
              <li>
                Make any unauthorised use of the Services, including collecting
                usernames and/or email addresses of users by electronic or other
                means for the purpose of sending unsolicited email, or creating
                user accounts by automated means or under false pretences.
              </li>
              <li>
                Use the Services as part of any effort to compete with us or
                otherwise use the Services and/or the Content for any
                revenue-generating endeavour or commercial enterprise.
              </li>
              <li>
                Use the Services to advertise or offer to sell goods and
                services.
              </li>
            </ul>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">
              USER GENERATED CONTRIBUTIONS
            </li>
            <p className="font-medium">
              The Services does not offer users to submit or post content. We
              may provide you with the opportunity to create, submit, post,
              display, transmit, perform, publish, distribute, or broadcast
              content and materials to us or on the Services, including but not
              limited to text, writings, video, audio, photographs, graphics,
              comments, suggestions, or personal information or other material
              (collectively, 'Contributions'). Contributions may be viewable by
              other users of the Services and through third-party websites. When
              you create or make available any Contributions, you thereby
              represent and warrant that:
            </p>
            <ul className="text-sm list-disc list-outside space-y-2 px-8 pt-6">
              <li>
                The creation, distribution, transmission, public display, or
                performance, and the accessing, downloading, or copying of your
                Contributions do not and will not infringe the proprietary
                rights, including but not limited to the copyright, patent,
                trademark, trade secret, or moral rights of any third party.
              </li>
              <li>
                You are the creator and owner of or have the necessary licences,
                rights, consents, releases, and permissions to use and to
                authorise us, the Services, and other users of the Services to
                use your Contributions in any manner contemplated by the
                Services and these Legal Terms.
              </li>
              <li>
                You have the written consent, release, and/or permission of each
                and every identifiable individual person in your Contributions
                to use the name or likeness of each and every such identifiable
                individual person to enable inclusion and use of your
                Contributions in any manner contemplated by the Services and
                these Legal Terms.
              </li>
              <li>
                Your Contributions are not false, inaccurate, or misleading.
              </li>
              <li>
                Your Contributions are not unsolicited or unauthorised
                advertising, promotional materials, pyramid schemes, chain
                letters, spam, mass mailings, or other forms of solicitation.
              </li>
              <li>
                Your Contributions are not obscene, lewd, lascivious, filthy,
                violent, harassing, libellous, slanderous, or otherwise
                objectionable (as determined by us).
              </li>
              <li>
                Your Contributions do not ridicule, mock, disparage, intimidate,
                or abuse anyone.
              </li>
              <li>
                Your Contributions are not used to harass or threaten (in the
                legal sense of those terms) any other person and to promote
                violence against a specific person or class of people.
              </li>
              <li>
                Your Contributions do not violate any applicable law,
                regulation, or rule.
              </li>
              <li>
                Your Contributions do not violate the privacy or publicity
                rights of any third party.
              </li>
              <li>
                Your Contributions do not violate any applicable law concerning
                child pornography, or otherwise intended to protect the health
                or well-being of minors.
              </li>
              <li>
                Your Contributions do not include any offensive comments that
                are connected to race, national origin, gender, sexual
                preference, or physical handicap.
              </li>
              <li>
                Your Contributions do not otherwise violate, or link to material
                that violates, any provision of these Legal Terms, or any
                applicable law or regulation.
              </li>
            </ul>
            <p className="font-medium pt-6">
              Any use of the Services in violation of the foregoing violates
              these Legal Terms and may result in, among other things,
              termination or suspension of your rights to use the Services.
            </p>
            <p className="font-medium pt-6">
              You and Services agree that we may access, store, process, and use
              any information and personal data that you provide and your
              choices (including settings).
            </p>
            <p className="font-medium pt-6">
              By submitting suggestions or other feedback regarding the
              Services, you agree that we can use and share such feedback for
              any purpose without compensation to you.
            </p>
            <p className="font-medium pt-6">
              We do not assert any ownership over your Contributions. You retain
              full ownership of all of your Contributions and any intellectual
              property rights or other proprietary rights associated with your
              Contributions. We are not liable for any statements or
              representations in your Contributions provided by you in any area
              on the Services. You are solely responsible for your Contributions
              to the Services and you expressly agree to exonerate us from any
              and all responsibility and to refrain from any legal action
              against us regarding your Contributions.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">
              MOBILE APPLICATION LICENCE
            </li>
            <h3 className="text-xl font-bold pb-2">Use Licence</h3>
            <p className="font-medium">
              If you access the Services via the App, then we grant you a
              revocable, non-exclusive, non-transferable, limited right to
              install and use the App on wireless electronic devices owned or
              controlled by you, and to access and use the App on such devices
              strictly in accordance with the terms and conditions of this
              mobile application licence contained in these Legal Terms. You
              shall not: (1) except as permitted by applicable law, decompile,
              reverse engineer, disassemble, attempt to derive the source code
              of, or decrypt the App; (2) make any modification, adaptation,
              improvement, enhancement, translation, or derivative work from the
              App; (3) violate any applicable laws, rules, or regulations in
              connection with your access or use of the App; (4) remove, alter,
              or obscure any proprietary notice (including any notice of
              copyright or trademark) posted by us or the licensors of the App;
              (5) use the App for any revenue-generating endeavour, commercial
              enterprise, or other purpose for which it is not designed or
              intended; (6) make the App available over a network or other
              environment permitting access or use by multiple devices or users
              at the same time; (7) use the App for creating a product, service,
              or software that is, directly or indirectly, competitive with or
              in any way a substitute for the App; (8) use the App to send
              automated queries to any website or to send any unsolicited
              commercial email; or (9) use any proprietary information or any of
              our interfaces or our other intellectual property in the design,
              development, manufacture, licensing, or distribution of any
              applications, accessories, or devices for use with the App.
            </p>

            <h3 className="text-xl font-bold py-2 mt-4">
              Apple and Android Devices
            </h3>
            <p className="font-medium">
              The following terms apply when you use the App obtained from
              either the Apple Store or Google Play (each an 'App Distributor')
              to access the Services: (1) the licence granted to you for our App
              is limited to a non-transferable licence to use the application on
              a device that utilises the Apple iOS or Android operating systems,
              as applicable, and in accordance with the usage rules set forth in
              the applicable App Distributor’s terms of service; (2) we are
              responsible for providing any maintenance and support services
              with respect to the App as specified in the terms and conditions
              of this mobile application licence contained in these Legal Terms
              or as otherwise required under applicable law, and you acknowledge
              that each App Distributor has no obligation whatsoever to furnish
              any maintenance and support services with respect to the App; (3)
              in the event of any failure of the App to conform to any
              applicable warranty, you may notify the applicable App
              Distributor, and the App Distributor, in accordance with its terms
              and policies, may refund the purchase price, if any, paid for the
              App, and to the maximum extent permitted by applicable law, the
              App Distributor will have no other warranty obligation whatsoever
              with respect to the App; (4) you represent and warrant that (i)
              you are not located in a country that is subject to a US
              government embargo, or that has been designated by the US
              government as a 'terrorist supporting' country and (ii) you are
              not listed on any US government list of prohibited or restricted
              parties; (5) you must comply with applicable third-party terms of
              agreement when using the App, e.g. if you have a VoIP application,
              then you must not be in violation of their wireless data service
              agreement when using the App; and (6) you acknowledge and agree
              that the App Distributors are third-party beneficiaries of the
              terms and conditions in this mobile application licence contained
              in these Legal Terms, and that each App Distributor will have the
              right (and will be deemed to have accepted the right) to enforce
              the terms and conditions in this mobile application licence
              contained in these Legal Terms against you as a third-party
              beneficiary thereof.
            </p>

            <p className="font-medium pt-10">
              As part of the functionality of the Services, you may link your
              account with online accounts you have with third-party service
              providers (each such account, a 'Third-Party Account') by either:
              (1) providing your Third-Party Account login information through
              the Services; or (2) allowing us to access your Third-Party
              Account, as is permitted under the applicable terms and conditions
              that govern your use of each Third-Party Account. You represent
              and warrant that you are entitled to disclose your Third-Party
              Account login information to us and/or grant us access to your
              Third-Party Account, without breach by you of any of the terms and
              conditions that govern your use of the applicable Third-Party
              Account, and without obligating us to pay any fees or making us
              subject to any usage limitations imposed by the third-party
              service provider of the Third-Party Account. By granting us access
              to any Third-Party Accounts, you understand that (1) we may
              access, make available, and store (if applicable) any content that
              you have provided to and stored in your Third-Party Account (the
              'Social Network Content') so that it is available on and through
              the Services via your account, including without limitation any
              friend lists and (2) we may submit to and receive from your
              Third-Party Account additional information to the extent you are
              notified when you link your account with the Third-Party Account.
              Depending on the Third-Party Accounts you choose and subject to
              the privacy settings that you have set in such Third-Party
              Accounts, personally identifiable information that you post to
              your Third-Party Accounts may be available on and through your
              account on the Services. Please note that if a Third-Party Account
              or associated service becomes unavailable or our access to such
              Third-Party Account is terminated by the third-party service
              provider, then Social Network Content may no longer be available
              on and through the Services. You will have the ability to disable
              the connection between your account on the Services and your
              Third-Party Accounts at any time. PLEASE NOTE THAT YOUR
              RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED
              WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR
              AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. We make no
              effort to review any Social Network Content for any purpose,
              including but not limited to, for accuracy, legality, or
              non-infringement, and we are not responsible for any Social
              Network Content. You acknowledge and agree that we may access your
              email address book associated with a Third-Party Account and your
              contacts list stored on your mobile device or tablet computer
              solely for purposes of identifying and informing you of those
              contacts who have also registered to use the Services. You can
              deactivate the connection between the Services and your
              Third-Party Account by contacting us using the contact information
              below or through your account settings (if applicable). We will
              attempt to delete any information stored on our servers that was
              obtained through such Third-Party Account, except the username and
              profile picture that become associated with your account.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">
              THIRD-PARTY WEBSITES AND CONTENT
            </li>
            <p className="font-medium">
              The Services may contain (or you may be sent via the App) links to
              other websites ('Third-Party Websites') as well as articles,
              photographs, text, graphics, pictures, designs, music, sound,
              video, information, applications, software, and other content or
              items belonging to or originating from third parties ('Third-Party
              Content'). Such Third-Party Websites and Third-Party Content are
              not investigated, monitored, or checked for accuracy,
              appropriateness, or completeness by us, and we are not responsible
              for any Third-Party Websites accessed through the Services or any
              Third-Party Content posted on, available through, or installed
              from the Services, including the content, accuracy, offensiveness,
              opinions, reliability, privacy practices, or other policies of or
              contained in the Third-Party Websites or the Third-Party Content.
              Inclusion of, linking to, or permitting the use or installation of
              any Third-Party Websites or any Third-Party Content does not imply
              approval or endorsement thereof by us. If you decide to leave the
              Services and access the Third-Party Websites or to use or install
              any Third-Party Content, you do so at your own risk, and you
              should be aware these Legal Terms no longer govern. You should
              review the applicable terms and policies, including privacy and
              data gathering practices, of any website to which you navigate
              from the Services or relating to any applications you use or
              install from the Services. Any purchases you make through
              Third-Party Websites will be through other websites and from other
              companies, and we take no responsibility whatsoever in relation to
              such purchases which are exclusively between you and the
              applicable third party. You agree and acknowledge that we do not
              endorse the products or services offered on Third-Party Websites
              and you shall hold us blameless from any harm caused by your
              purchase of such products or services. Additionally, you shall
              hold us blameless from any losses sustained by you or harm caused
              to you relating to or resulting in any way from any Third-Party
              Content or any contact with Third-Party Websites.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">ADVERTISERS</li>
            <p className="font-medium">
              We allow advertisers to display their advertisements and other
              information in certain areas of the Services, such as sidebar
              advertisements or banner advertisements. We simply provide the
              space to place such advertisements, and we have no other
              relationship with advertisers.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">SERVICES MANAGEMENT</li>
            <p className="font-medium">
              We reserve the right, but not the obligation, to: (1) monitor the
              Services for violations of these Legal Terms; (2) take appropriate
              legal action against anyone who, in our sole discretion, violates
              the law or these Legal Terms, including without limitation,
              reporting such user to law enforcement authorities; (3) in our
              sole discretion and without limitation, refuse, restrict access
              to, limit the availability of, or disable (to the extent
              technologically feasible) any of your Contributions or any portion
              thereof; (4) in our sole discretion and without limitation,
              notice, or liability, to remove from the Services or otherwise
              disable all files and content that are excessive in size or are in
              any way burdensome to our systems; and (5) otherwise manage the
              Services in a manner designed to protect our rights and property
              and to facilitate the proper functioning of the Services.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">PRIVACY POLICY</li>
            <p className="font-medium">
              We care about data privacy and security. By using the Services,
              you agree to be bound by our Privacy Policy posted on the
              Services, which is incorporated into these Legal Terms. Please be
              advised the Services are hosted in Egypt and Saudi Arabia. If you
              access the Services from any other region of the world with laws
              or other requirements governing personal data collection, use, or
              disclosure that differ from applicable laws in Egypt and Saudi
              Arabia, then through your continued use of the Services, you are
              transferring your data to Egypt and Saudi Arabia, and you
              expressly consent to have your data transferred to and processed
              in Egypt and Saudi Arabia.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">TERM AND TERMINATION</li>
            <p className="font-medium">
              These Legal Terms shall remain in full force and effect while you
              use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
              LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
              WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE
              SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON
              FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR
              BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN
              THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY
              TERMINATE YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR
              ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY
              TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
            </p>

            <p className="font-medium pt-4">
              If we terminate or suspend your account for any reason, you are
              prohibited from registering and creating a new account under your
              name, a fake or borrowed name, or the name of any third party,
              even if you may be acting on behalf of the third party. In
              addition to terminating or suspending your account, we reserve the
              right to take appropriate legal action, including without
              limitation pursuing civil, criminal, and injunctive redress.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">
              MODIFICATIONS AND INTERRUPTIONS
            </li>
            <p className="font-medium">
              We reserve the right to change, modify, or remove the contents of
              the Services at any time or for any reason at our sole discretion
              without notice. However, we have no obligation to update any
              information on our Services. We also reserve the right to modify
              or discontinue all or part of the Services without notice at any
              time. We will not be liable to you or any third party for any
              modification, price change, suspension, or discontinuance of the
              Services.
            </p>

            <p className="font-medium pt-4">
              We cannot guarantee the Services will be available at all times.
              We may experience hardware, software, or other problems or need to
              perform maintenance related to the Services, resulting in
              interruptions, delays, or errors. We reserve the right to change,
              revise, update, suspend, discontinue, or otherwise modify the
              Services at any time or for any reason without notice to you. You
              agree that we have no liability whatsoever for any loss, damage,
              or inconvenience caused by your inability to access or use the
              Services during any downtime or discontinuance of the Services.
              Nothing in these Legal Terms will be construed to obligate us to
              maintain and support the Services or to supply any corrections,
              updates, or releases in connection therewith.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">GOVERNING LAW</li>
            <p className="font-medium">
              These Legal Terms shall be governed by and defined following the
              laws of Saudi Arabia. Specter and yourself irrevocably consent
              that the courts of Saudi Arabia shall have exclusive jurisdiction
              to resolve any dispute which may arise in connection with these
              Legal Terms.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold">DISPUTE RESOLUTION</li>
            <h3 className="text-xl font-bold py-3">Informal Negotiations</h3>
            <p className="font-medium">
              To expedite resolution and control the cost of any dispute,
              controversy, or claim related to these Legal Terms (each a
              'Dispute' and collectively, the 'Disputes') brought by either you
              or us (individually, a 'Party' and collectively, the 'Parties'),
              the Parties agree to first attempt to negotiate any Dispute
              (except those Disputes expressly provided below) informally for at
              least thirty (30) days before initiating arbitration. Such
              informal negotiations commence upon written notice from one Party
              to the other Party.
            </p>

            <h3 className="text-xl font-bold py-3">Binding Arbitration</h3>
            <p className="font-medium">
              Any dispute arising out of or in connection with these Legal
              Terms, including any question regarding its existence, validity,
              or termination, shall be referred to and finally resolved by the
              International Commercial Arbitration Court under the European
              Arbitration Chamber (Belgium, Brussels, Avenue Louise, 146)
              according to the Rules of this ICAC, which, as a result of
              referring to it, is considered as the part of this clause. The
              number of arbitrators shall be <p>_______________</p> . The seat,
              or legal place, or arbitration shall be Saudi Arabia . The
              language of the proceedings shall be<p>_______________</p> . The
              governing law of these Legal Terms shall be substantive law of
              Saudi Arabia.
            </p>

            <h3 className="text-xl font-bold py-3 mt-4">Restrictions</h3>
            <p className="font-medium">
              The Parties agree that any arbitration shall be limited to the
              Dispute between the Parties individually. To the full extent
              permitted by law, (a) no arbitration shall be joined with any
              other proceeding; (b) there is no right or authority for any
              Dispute to be arbitrated on a class-action basis or to utilise
              class action procedures; and (c) there is no right or authority
              for any Dispute to be brought in a purported representative
              capacity on behalf of the general public or any other persons.
            </p>

            <h3 className="text-xl font-bold py-3 mt-4">
              Exceptions to Informal Negotiations and Arbitration
            </h3>
            <p className="font-medium">
              The Parties agree that the following Disputes are not subject to
              the above provisions concerning informal negotiations binding
              arbitration: (a) any Disputes seeking to enforce or protect, or
              concerning the validity of, any of the intellectual property
              rights of a Party; (b) any Dispute related to, or arising from,
              allegations of theft, piracy, invasion of privacy, or unauthorised
              use; and (c) any claim for injunctive relief. If this provision is
              found to be illegal or unenforceable, then neither Party will
              elect to arbitrate any Dispute falling within that portion of this
              provision found to be illegal or unenforceable and such Dispute
              shall be decided by a court of competent jurisdiction within the
              courts listed for jurisdiction above, and the Parties agree to
              submit to the personal jurisdiction of that court.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">CORRECTIONS</li>
            <p className="font-medium">
              There may be information on the Services that contains
              typographical errors, inaccuracies, or omissions, including
              descriptions, pricing, availability, and various other
              information. We reserve the right to correct any errors,
              inaccuracies, or omissions and to change or update the information
              on the Services at any time, without prior notice.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">DISCLAIMER</li>
            <p className="font-medium">
              THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
              AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
              THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
              EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
              THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT
              THE ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT OR THE
              CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE
              SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
              (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS,
              (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
              RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY
              UNAUTHORISED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
              ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
              THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
              FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
              LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY
              THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND
              MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
              RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE
              MADE AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE,
              GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
              ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SERVICES, ANY
              HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED
              IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO
              OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION
              BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.
              AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR
              IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGEMENT AND
              EXERCISE CAUTION WHERE APPROPRIATE.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">LIMITATIONS OF LIABILITY</li>
            <p className="font-medium">
              IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
              LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
              CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
              DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
              OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE
              HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
              NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR
              LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE
              FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER OF
              THE AMOUNT PAID, IF ANY, BY YOU TO US OR . CERTAIN US STATE LAWS
              AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED
              WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF
              THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR
              LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL
              RIGHTS.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">INDEMNIFICATION</li>
            <p className="font-medium">
              You agree to defend, indemnify, and hold us harmless, including
              our subsidiaries, affiliates, and all of our respective officers,
              agents, partners, and employees, from and against any loss,
              damage, liability, claim, or demand, including reasonable
              attorneys’ fees and expenses, made by any third party due to or
              arising out of: (1) use of the Services; (2) breach of these Legal
              Terms; (3) any breach of your representations and warranties set
              forth in these Legal Terms; (4) your violation of the rights of a
              third party, including but not limited to intellectual property
              rights; or (5) any overt harmful act toward any other user of the
              Services with whom you connected via the Services. Notwithstanding
              the foregoing, we reserve the right, at your expense, to assume
              the exclusive defence and control of any matter for which you are
              required to indemnify us, and you agree to cooperate, at your
              expense, with our defence of such claims. We will use reasonable
              efforts to notify you of any such claim, action, or proceeding
              which is subject to this indemnification upon becoming aware of
              it.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">USER DATA</li>
            <p className="font-medium">
              We will maintain certain data that you transmit to the Services
              for the purpose of managing the performance of the Services, as
              well as data relating to your use of the Services. Although we
              perform regular routine backups of data, you are solely
              responsible for all data that you transmit or that relates to any
              activity you have undertaken using the Services. You agree that we
              shall have no liability to you for any loss or corruption of any
              such data, and you hereby waive any right of action against us
              arising from any such loss or corruption of such data.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">
              ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
            </li>
            <p className="font-medium">
              Visiting the Services, sending us emails, and completing online
              forms constitute electronic communications. You consent to receive
              electronic communications, and you agree that all agreements,
              notices, disclosures, and other communications we provide to you
              electronically, via email and on the Services, satisfy any legal
              requirement that such communication be in writing. YOU HEREBY
              AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND
              OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES,
              AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA
              THE SERVICES. You hereby waive any rights or requirements under
              any statutes, regulations, rules, ordinances, or other laws in any
              jurisdiction which require an original signature or delivery or
              retention of non-electronic records, or to payments or the
              granting of credits by any means other than electronic means.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">MISCELLANEOUS</li>
            <p className="font-medium">
              These Legal Terms and any policies or operating rules posted by us
              on the Services or in respect to the Services constitute the
              entire agreement and understanding between you and us. Our failure
              to exercise or enforce any right or provision of these Legal Terms
              shall not operate as a waiver of such right or provision. These
              Legal Terms operate to the fullest extent permissible by law. We
              may assign any or all of our rights and obligations to others at
              any time. We shall not be responsible or liable for any loss,
              damage, delay, or failure to act caused by any cause beyond our
              reasonable control. If any provision or part of a provision of
              these Legal Terms is determined to be unlawful, void, or
              unenforceable, that provision or part of the provision is deemed
              severable from these Legal Terms and does not affect the validity
              and enforceability of any remaining provisions. There is no joint
              venture, partnership, employment or agency relationship created
              between you and us as a result of these Legal Terms or use of the
              Services. You agree that these Legal Terms will not be construed
              against us by virtue of having drafted them. You hereby waive any
              and all defences you may have based on the electronic form of
              these Legal Terms and the lack of signing by the parties hereto to
              execute these Legal Terms.
            </p>
          </div>

          <div>
            <li className="text-xl font-bold pb-2">CONTACT US</li>
            <p className="font-medium">
              In order to resolve a complaint regarding the Services or to
              receive further information regarding use of the Services.
            </p>
          </div>
        </ol>

        <h2 className="text-xl font-bold pt-8">Privacy Policy</h2>
        <h3 className="font-bold pb-4">
          At Specter, we collect and manage user data according to the following
          Privacy Policy.
        </h3>
        <ol className="list-decimal list-inside space-y-6">
          <div>
            <li className="text-xl font-semibold pb-2">Data Collected</li>
            <p className="font-medium">
              We collect information you provide directly to us. For example, we
              collect information when you create an account, subscribe,
              participate in any interactive features of our services, fill out
              a form, request customer support or otherwise communicate with us.
              The types of information we may collect include your name, email
              address, postal address, credit card information and other contact
              or identifying information you choose to provide.
            </p>
            <p className="font-medium">
              We collect anonymous data from every visitor of the Website to
              monitor traffic and fix bugs. For example, we collect information
              like web requests, the data sent in response to such requests, the
              Internet Protocol address, the browser type, the browser language,
              and a timestamp for the request.
            </p>
            <p className="font-medium">
              We also use various technologies to collect information, and this
              may include sending cookies to your computer. Cookies are small
              data files stored on your hard drive or in your device memory that
              helps us to improve our services and your experience, see which
              areas and features of our services are popular and count visits.
              We may also collect information using web beacons (also known as
              'tracking pixels'). Web beacons are electronic images that may be
              used in our services or emails and to track count visits or
              understand usage and campaign effectiveness.
            </p>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">
              Third Party Log-In Services
            </li>
            <p className="font-medium">
              We allow you to register and log in to Lucky using Facebook and
              Google. These services authenticate your identity and provide you
              the option to share certain personal information with us such as
              your name and email address in order to create your Lucky account.
              We may integrate with, and make available to you, other
              third-party log-in services in the future.
            </p>
            <p className="font-medium">
              Please refer to points 3, 4, 5 and 6 of this Privacy Policy to
              understand how this data is protected and used by Lucky.
            </p>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">Use of the Data</li>
            <p className="font-medium">
              We only use your personal information to provide you with Lucky’s
              services or to communicate with you about the services provided by
              Lucky. We employ industry standard techniques to protect against
              unauthorized access of data about you that we store, including
              personal information. We do not share personal information you
              have provided to us without your consent, unless:
            </p>
            <ul className="text-sm list-disc list-outside space-y-2 px-10 py-2">
              <li>Doing so is appropriate to carry out your own request.</li>
              <li>
                We believe it's needed to enforce our legal agreements or that
                is legally required.
              </li>
              <li>
                We believe it's needed to detect, prevent or address fraud,
                security or technical issues.
              </li>
            </ul>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">Sharing of Data</li>
            <p className="font-medium pb-3">
              We don't share your personal information with third parties.
              Aggregated, anonymized data is periodically transmitted to
              external services to help us improve the Website and service.
            </p>
            <p className="font-medium pb-3">
              We may allow third parties to provide analytics services. These
              third parties may use cookies, web beacons and other technologies
              to collect information about your use of the services and other
              websites, including your IP address, web browser, pages viewed,
              time spent on pages, links clicked and conversion information.
            </p>
            <p className="font-medium pb-3">
              We also use social buttons provided by services like Twitter,
              Google+, LinkedIn and Facebook. Your use of these third party
              services is entirely optional. We are not responsible for the
              privacy policies and/or practices of these third party services,
              and you are responsible for reading and understanding those third
              party services' privacy policies.
            </p>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">
              Opt-Out, Communication Preferences
            </li>
            <p className="font-medium pb-3">
              You may modify your communication preferences and/or opt-out from
              specific communications at any time. Please specify and adjust
              your preferences.
            </p>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">Security</li>
            <p className="font-medium pb-3">
              We take reasonable steps to protect personally identifiable
              information from loss, misuse, and unauthorized access,
              disclosure, alteration, or destruction. But, you should keep in
              mind that no Internet transmission is ever completely secure or
              error-free. In particular, email sent to or from the Sites may not
              be secure.
            </p>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">Account Deletion</li>
            <p className="font-medium pb-3">
              You also have the right to delete your account by selecting Quick
              Help, through which you can contact Customer Support and inform
              them of your wish to delete your account. We may retain user data
              after your deletion request for a legally prescribed period of
              time in conformity with any local legal or regulatory
              requirements. Following an account deletion request, we delete the
              user’s account and data, unless they must be retained due to legal
              or regulatory requirements, for purposes of safety, security, and
              fraud prevention, or because of an issue relating to the user’s
              account such as an outstanding credit or an unresolved claim or
              dispute. Because we are subject to legal and regulatory
              requirements relating to users, this generally means that we
              retain their account and data for the applicable statutory
              retention period after a deletion request. Data is generally
              deleted within 3 working days of a deletion request, except where
              retention is necessary for the above reasons.
            </p>
          </div>

          <div>
            <li className="text-xl font-semibold pb-2">
              Changes to the Privacy Policy
            </li>
            <p className="font-medium pb-3">
              We may amend this Privacy Policy from time to time. Use of
              information we collect now is subject to the Privacy Policy in
              effect at the time such information is used. If we make major
              changes in the way we collect or use information, we will notify
              you by posting an announcement on Lucky.com or sending you an
              email.
            </p>
          </div>
        </ol>
      </div>

      <div className=" bg-slate-200 py-6 mt-8">
        <div className="container mx-auto px-10 flex justify-between">
          <h1 className="text-xl font-bold">Contact Us</h1>
          <div className="flex gap-2 text-lg">
            <h2 className="font-bold">Email : </h2>
            <p className="font-medium">Specter@gmail.com</p>
          </div>
          <div className="flex gap-2 text-lg">
            <h2 className="font-bold">Mobile : </h2>
            <p className="font-medium">+966 55 461 3199</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
